import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import Vconsole from "vconsole";
import { isDev } from "./config.js";
import { createPinia } from "pinia";
import "./styles/element-override.scss";
import { createHead } from "@unhead/vue";
import { useAdStore } from './store/adStore';

const app = createApp(App);
const head = createHead();

const pinia = createPinia();

app.use(pinia);
app.use(head);
app.use(router);

if (isDev) {
  new Vconsole();
  // app.use(vconsole);
}

app.mount("#app");

const adStore = useAdStore(pinia);

window.gdtOnAdLoaded = (placementId, ads) => {
  adStore.setSdkReady();
  if (ads && ads.length > 0) {
    adStore.addAds(placementId, ads);
  } else {
    console.warn(`[window.gdtOnAdLoaded] Received success callback for ${placementId} but no valid ads.`);
    adStore.handleLoadFailure(placementId, { ret: 0, msg: 'Success callback with empty or invalid ads data' });
  }
};

window.gdtOnAdLoadFailed = (placementId, res) => {
  adStore.setSdkReady();
  adStore.handleLoadFailure(placementId, res);
};
